import Mutations from '../../odata/mutations';

export default { ...new Mutations('article'), ...new Mutations('articles') };
